// sagas.ts
import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchOrderHistoryFailure, fetchOrderHistorySuccess, fetchOrderMatchHistoryFailure, fetchOrderMatchHistorySuccess } from './actions';
import api from '../../../api-new/http';
import { appUrls } from '../../../api-new/urls';
import {
    FETCH_ORDER_HISTORY_REQUEST,
    FETCH_ORDER_MATCH_HISTORY_REQUEST,
} from './constants';
import { sendError } from '../../public/errorHandler';
import { getErrorSetup } from '../../../helpers/getErrorSetup';

export function* orderHistorySaga() {
    try {
        const data = yield call(() =>
            api.get(`${appUrls.tradeURL}/open-order`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('csrfToken')}`,
                },
            }),
        );
        if (data) {
            yield put(fetchOrderHistorySuccess(data.data.data));
        }
    } catch (error) {
        yield put(fetchOrderHistoryFailure(error as any));
        yield put(
            sendError({
                error: getErrorSetup(error),
                processingType: 'alert',
            }),
        );
    }
}

export function* orderMatchHistorySaga() {
    try {
        const data = yield call(() =>
            api.get(`${appUrls.tradeURL}/user/match-histories/`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('csrfToken')}`,
                },
            }),
        );
        if (data) {
            yield put(fetchOrderMatchHistorySuccess(data.data.data));
        }
    } catch (error) {
        yield put(fetchOrderMatchHistoryFailure(error as any));
        yield put(
            sendError({
                error: getErrorSetup(error),
                processingType: 'alert',
            }),
        );
    }
}

export function* rootStockOrderHistorySaga(): Generator {
    yield takeLatest(FETCH_ORDER_HISTORY_REQUEST, orderHistorySaga);
    yield takeLatest(FETCH_ORDER_MATCH_HISTORY_REQUEST, orderMatchHistorySaga);
}
